import React from 'react';
import WarningModal from '../WarningModal';
import { formatMessage } from '@/utils/i18n';
import { connect } from 'react-redux';
import { clearHoldings, setHoldingToReplace, setShowTaxDetails } from '@/redux/modules/edit-portfolio';
import { withErrorBoundary } from '@/views/components/errors';
import PortfolioHolding from '@/types/portfolio-holding';
import { ReduxState } from '@/redux/modules/types';

type DispatchProps = {
  clearHoldings: () => void;
  setHoldingToReplace: (holdingToReplace?: PortfolioHolding) => void;
  setShowTaxDetails: (show: boolean) => void;
};

type StateProps = {
  holdingToReplace?: PortfolioHolding;
};

type Props = DispatchProps &
  StateProps & {
    show: boolean;
    onClose: () => void;
  };

const ClearPortfolioHoldingsModal = ({ clearHoldings, show, onClose, holdingToReplace, setHoldingToReplace, setShowTaxDetails }: Props) => {
  const onConfirm = () => {
    clearHoldings();
    setShowTaxDetails(false);
    onClose();

    if (holdingToReplace) {
      setHoldingToReplace(undefined);
    }
  };

  return (
    <WarningModal
      backdropClassName="modal-v2-backdrop"
      show={show}
      onConfirm={onConfirm}
      onCancel={onClose}
      isV2
      title={formatMessage('PortfolioEditorBuilder.Footer.ClearPortfolioHoldingsModal.Title')}
      body={formatMessage('PortfolioEditorBuilder.Footer.ClearPortfolioHoldingsModal.Body')}
    />
  );
};

const mapStateToProps = (state: ReduxState) => ({
  holdingToReplace: state.editPortfolio.holdingToReplace,
});

export default connect(mapStateToProps, {
  clearHoldings,
  setHoldingToReplace,
  setShowTaxDetails,
})(withErrorBoundary(ClearPortfolioHoldingsModal));
